import jscookie from 'js-cookie'

class LocalDB {
  all() {
    return jscookie.get()
  }

  get(path, defaultValue) {
    const data = jscookie.get(path)

    if (!data) {
      return defaultValue
    }

    return data
  }

  set(...args) {
    return jscookie.set(...args)
  }

  storeToken(token) {
    return this.set('spoke_stok', token, {
      expires: 365,
      // should be 'strict' but causes problem on IOS for now : cf https://github.com/mediameeting/bubblecast/issues/447
      sameSite: 'Lax',
      secure: process.env.NODE_ENV === 'production',
    })
  }

  remove(...args) {
    return jscookie.remove(...args)
  }
}

export default new LocalDB()
